import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type State = {
  gridHelper: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setGridHelper: (grid: boolean) => void
}

const usePersistStore = create(
  persist<State & Actions>(
    (set) => ({
      gridHelper: false,
      setGridHelper: (gridHelper) => set(() => ({ gridHelper }))
    }),
    {
      name: 'grid-helper', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage) // (optional) by default, 'localStorage' is used
    }
  )
)

export { usePersistStore }
